/**
 * FJ Product Card - Variant Swatches & Direct Add to Cart
 * Handles variant swatches, image swapping, and AJAX add-to-cart
 */

(function() {
  'use strict';

  // Handle variant swatch selection
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.fj-swatch');
    if (!swatch || swatch.classList.contains('is-disabled')) return;

    const card = swatch.closest('.fj-card');
    if (!card) return;

    // Update active state
    const swatchGroup = swatch.closest('.fj-swatch-group');
    swatchGroup.querySelectorAll('.fj-swatch').forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    // Update product image if variant has image
    const variantImage = swatch.dataset.variantImage;
    if (variantImage) {
      const productImage = card.querySelector('.fj-card__img');
      if (productImage) {
        productImage.src = variantImage;
      }
    }

    // Update stock popup based on variant availability
    const stockPopup = card.querySelector('.fj-stock-popup');
    if (stockPopup) {
      const isAvailable = swatch.dataset.variantAvailable === 'true';
      const isOnSupplier = swatch.dataset.onSupplier === 'true';

      // Get the current store location and supplier days from existing elements
      const deliveryEl = stockPopup.querySelector('.fj-stock-popup__delivery');
      const currentDeliveryText = deliveryEl ? deliveryEl.textContent : '';

      // Extract store location from existing text (e.g., "Hent i dag på Tau" -> "Tau")
      const storeMatch = currentDeliveryText.match(/på\s+(.+)$/);
      const storeLocation = storeMatch ? storeMatch[1] : 'Tau';

      // Get supplier days from swatch title attribute
      const titleAttr = swatch.getAttribute('title') || '';
      const daysMatch = titleAttr.match(/(\d+-?\d*)\s*dager/);
      const supplierDays = daysMatch ? daysMatch[1] : '2-4';

      if (isAvailable && !isOnSupplier) {
        // In stock locally
        stockPopup.innerHTML = `
          <div class="fj-stock-popup__item fj-stock-popup__item--instock">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            <span>På lager</span>
          </div>
          <div class="fj-stock-popup__delivery">Hent i dag på ${storeLocation}</div>
        `;
      } else if (isOnSupplier) {
        // Available from supplier warehouse only
        stockPopup.innerHTML = `
          <div class="fj-stock-popup__item fj-stock-popup__item--supplier">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="1" y="3" width="15" height="13"/>
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
              <circle cx="5.5" cy="18.5" r="2.5"/>
              <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
            <span>Fjernlager</span>
          </div>
          <div class="fj-stock-popup__delivery">Leveres innen ${supplierDays} virkedager</div>
        `;
      } else {
        // Out of stock
        stockPopup.innerHTML = `
          <div class="fj-stock-popup__item fj-stock-popup__item--out">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
            <span>Utsolgt</span>
          </div>
        `;
      }
    }

    // Update hidden input with selected variant ID (for add-to-cart)
    const variantId = swatch.dataset.variantId;
    const form = card.querySelector('.fj-card__add-to-cart-form');
    if (form && variantId) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
      }
    }

    // Update "Velg alternativer" button with selected variant
    const quickViewBtn = card.querySelector('.fj-quick-view-trigger');
    if (quickViewBtn && variantId) {
      quickViewBtn.dataset.selectedVariant = variantId;
    }
  });

  // Handle direct add-to-cart from product cards
  document.addEventListener('submit', async function(e) {
    const form = e.target.closest('.fj-card__add-to-cart-form');
    if (!form) return;

    e.preventDefault();

    const button = form.querySelector('.fj-quick-add-btn');
    if (!button) return;

    const originalHTML = button.innerHTML;

    // Loading state
    button.disabled = true;
    button.innerHTML = '<span class="fj-spinner"></span> Legger til...';

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Success - update cart count and show feedback
      button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> Lagt til!';

      // Update cart count if cart drawer exists
      updateCartCount();

      // Open cart drawer
      openCartDrawer();

      // Reset button after 2 seconds
      setTimeout(() => {
        button.disabled = false;
        button.innerHTML = originalHTML;
      }, 2000);

    } catch (error) {
      console.error('Add to cart failed:', error);
      button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg> Feil - prøv igjen';

      setTimeout(() => {
        button.disabled = false;
        button.innerHTML = originalHTML;
      }, 2000);
    }
  });

  // Update cart count in header and bottom nav
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;

      const cart = await response.json();

      // Update header cart count
      const headerCounts = document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble span');
      headerCounts.forEach(el => {
        el.textContent = cart.item_count;
      });

      // Update bottom nav cart count
      const bottomNavCount = document.querySelector('.fj-cart-count');
      if (bottomNavCount) {
        bottomNavCount.textContent = cart.item_count;
        if (cart.item_count > 0) {
          bottomNavCount.style.display = 'flex';
        }
      }

    } catch (error) {
      console.error('Failed to update cart count:', error);
    }
  }

  // Open cart drawer after adding item
  function openCartDrawer() {
    // Try Dawn's cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    }

    // Try details/summary cart drawer
    const cartDetails = document.querySelector('#cart-drawer');
    if (cartDetails) {
      const summary = cartDetails.querySelector('summary');
      if (summary) {
        summary.click();
        return true;
      }
    }

    // Try cart notification
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
      return true;
    }

    // Fallback: trigger custom event for other cart implementations
    document.dispatchEvent(new CustomEvent('fj:cart-item-added'));

    return false;
  }

  // Handle "Les mer" description toggle
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.fj-card__desc-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const desc = btn.nextElementSibling;

    if (desc) {
      btn.setAttribute('aria-expanded', !expanded);
      desc.hidden = expanded;
    }
  });

})();
